import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminMediaSubmissions from "@/pages/admin/AdminMediaSubmissions";

export const Route = createFileRoute("/admin/media-submissions/")({
  head: () => pageHead("Admin \u2014 Media Submissions \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminMediaSubmissions,
});
